import Vue from 'vue'
import Vuex from 'vuex'
const fb = require('../firebaseConfig.js')

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    currentUser: null,
    userProfile: {},
    timestamp: '0/1/2021 10:25',
    mildHypoThreshold: 65,
    bpTargetMin: 65,
    bpTargetMax: 85,
    brightness: 1.0
  },
  mutations: {
    setCurrentUser(state, val) {
      state.currentUser = val
    },
    setUserProfile(state, val) {
      state.userProfile = val
    },
    setTimestamp(state, val) {
      state.timestamp = val
    },
    setBPTargetMax(state, val) {
      state.bpTargetMax = parseInt(val, 10)
    },
    setBPTargetMin(state, val) {
      state.bpTargetMin = parseInt(val, 10)
    },
    setMildHypoThreshold(state, val) {
      state.mildHypoThreshold = parseInt(val, 10)
    },
    setBrightness(state, val) {
      state.brightness = val
    }
  },
  actions: {
    fetchUserProfile({ commit, state }) {
      fb.usersCollection
        .doc(state.currentUser.uid)
        .get()
        .then(res => {
          commit('setUserProfile', res.data())
        })
        .catch(err => {})
    }
  },
  modules: {}
})
